export const ReadStatus = {
  NEW: 'new',
  READ: 'read'
};

export const READ_STATUS = Object.values(ReadStatus);

export default ReadStatus;
